import config from '../../../config'
import store from '../../store'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async get_menus({}, filtro = {}) {
      return await new Promise(async (resolve, reject) => {
        try {
          const params = new URLSearchParams({
            nombre: filtro.nombre || '',
            nivel: filtro.nivel ?? '',
            padre: filtro.padre ?? '',
            inhabilitado: filtro.inhabilitado ?? 0
          }).toString()
          const res = await fetch(`${config.API_URL}/menus-nuevo/search?${params}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_menu_by_id({}, id) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/menus-nuevo/${id}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_menus_tree() {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/menus-nuevo/tree`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async crear_menu({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/menus-nuevo`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            },
            body: JSON.stringify({
              nombre: payload.nombre,
              url: payload.url || null,
              icono: payload.icono || null,
              nivel: payload.nivel ?? 1,
              menu_padre_id: payload.menu_padre_id || null,
              orden: payload.orden ?? 0
            })
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async editar_menu({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/menus-nuevo/${payload.id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            },
            body: JSON.stringify({
              nombre: payload.nombre,
              url: payload.url || null,
              icono: payload.icono || null,
              nivel: payload.nivel ?? 1,
              menu_padre_id: payload.menu_padre_id || null,
              orden: payload.orden ?? 0,
              inhabilitado: payload.inhabilitado ?? false
            })
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async habilitar_menu({}, id) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/menus-nuevo/${id}/habilitar`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async inhabilitar_menu({}, id) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/menus-nuevo/${id}/inhabilitar`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_opciones_menu() {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/menus-nuevo/opciones`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    }
  }
}
